// extracted by mini-css-extract-plugin
export default {"reply":"ZOqV6","reply_side_main":"pikDd","reply_side_opposite":"bwLnx","reply__text":"WgXaC"};